// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("ogg-opus-decoder." + "opus-ml" + ".min.js");